import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{background: 'linear-gradient(360deg, #08222AFF 10%, #274F5BFF 90%)', color:'white', py: 4 }}>
      <Container>
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} spacing={4}>
          <Box flex={1}>
            <Typography variant="h5" gutterBottom>
              OVGuru
            </Typography>
            <Typography variant="h7" sx={{ opacity: 0.6 }}>
              Copyright © {new Date().getFullYear()} - omnevu.com
            </Typography>
          </Box>
          <Box flex={1}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Link href="/admin" color="inherit">Admin</Link><br />
            <Link href="/mentor" color="inherit">Mentor</Link><br />
          </Box>
          <Box flex={1}>
            <Typography variant="h6" gutterBottom>
              Our Policies
            </Typography>
            <Link href="about:blank" target="_blank" rel="noreferrer" color="inherit">Terms & Conditions</Link><br />
            <Link href="about:blank" target="_blank" rel="noreferrer" color="inherit">Privacy Policy</Link><br />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;